import dynamic from "next/dynamic";
import SkeletonListReview from "components/skeleton/list_review/listReview";

const TrandingReview = dynamic(
	() => import("Containers/tranding_review/trandingReview"), { loading: () => <SkeletonListReview isMobile />, ssr: true },
);

const Mobile = (props) => {

	const prop = props;

	return (
		<div className="container" id="card-top">

			<TrandingReview
				{...prop}
			/>

			<style jsx>
				{`
					.container{
						display: flex;
						flex-direction: column;
						align-items: center;
						width: 100%;
					}
				`}
			</style>
		</div>

	);

};

export default Mobile;
